require('./lbHotelPriceCheckModal.scss');

const lbHotelPriceCheckModal = angular.module('app.lbHotelPriceCheckModal', []);

lbHotelPriceCheckModal.component('lbHotelPriceCheckModal', {
  controllerAs: 'vm',
  controller: ['lbModalService', lbHotelPriceCheckModalCtrl],
  template: require('./lbHotelPriceCheckModal.html'),
});

function lbHotelPriceCheckModalCtrl(lbModalService) {
  let vm = this;

  vm.display = lbModalService.params().display;
  vm.status = lbModalService.params().status;

  vm.close = lbModalService.resolve;
}

export default lbHotelPriceCheckModal;



// WEBPACK FOOTER //
// ./src/components/lbHotelPriceCheckModal/lbHotelPriceCheckModal.js